import { combineReducers } from 'redux';
import homePage from './homePage';

const uiReducer = combineReducers({
  homePage,
});

export default uiReducer;
